<template>
  <div class="questionnaire-sidebar flex flex-col h-full min-h-0
   bg-white rounded-xl border border-gray-200
   p-3 w-80 box-border overflow-hidden">
    <h3 class="sidebar-title shrink-0 text-base font-semibold text-gray-900 mb-2">
      {{ $t('QuestionnaireSidebar.summary', 'Summary') }}
    </h3>
    <div class="sidebar-progress shrink-0 mb-2">
      <ProgressBar :value="progress" :show-value="true" class="sidebar-progress-bar mb-1" />
      <p class="sidebar-progress-text text-sm text-gray-500 m-0">
        {{ answeredCount }} / {{ totalQuestions }}
         {{ $t('QuestionnaireSidebar.answered', 'answered') }}
      </p>
    </div>
    <div class="sidebar-questions flex flex-col min-h-0 flex-1">
      <p class="sidebar-questions-label shrink-0 text-sm font-semibold text-gray-900 mb-1.5">
        {{ $t('QuestionnaireSidebar.jumpTo', 'Jump to question') }}
      </p>
      <div class="question-list-wrap flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
        <ul class="question-list list-none p-0 m-0">
          <li
            v-for="(item, i) in answeredQuestions"
            :key="i"
            class="question-list-item py-2.5 px-2 border-b border-gray-100
             text-[0.9375rem] leading-tight transition-colors
              last:border-b-0"
            :class="{
              'bg-orange-100/80 font-semibold': item.index === currentIndex,
              'cursor-pointer hover:bg-orange-50': isReachable(item.index),
              'opacity-40 cursor-not-allowed': !isReachable(item.index),
            }"
            @click="jumpTo(item.index)"
          >
            <span class="question-list-text">
              {{ item.questionText || $t('QuestionnaireSidebar.question', 'Question') }}
            </span>
            <span v-if="item.hasAnswer" class="question-list-answer mt-1.5
             inline-block text-sm font-semibold text-orange-600 bg-orange-50
              border border-orange-200 rounded-md px-2 py-0.5">
              {{ answerLabel(item) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from 'primevue/progressbar';

const SLIDER_KEYS = ['stronglyDisagree', 'disagree', 'indifferent', 'agree', 'stronglyAgree'];

export default {
  name: 'QuestionnaireSidebar',
  components: { ProgressBar },
  computed: {
    progress() {
      return Math.round(this.$store.getters.getProgress || 0);
    },
    answeredQuestions() {
      return this.$store.getters.getAnsweredQuestions || [];
    },
    totalQuestions() {
      return this.$store.state.questionnaireManagement?.questions?.length ?? 0;
    },
    answeredCount() {
      return this.answeredQuestions.filter((q) => q.hasAnswer).length;
    },
    currentIndex() {
      return this.$store.getters.getQuestionnaireIndex ?? 0;
    },
    maxReachableIndex() {
      const assessment = this.$store.state.questionnaireManagement?.assessment;
      return assessment?.saved_until_question ?? this.currentIndex;
    },
  },
  methods: {
    isReachable(index) {
      return index <= this.maxReachableIndex;
    },
    jumpTo(index) {
      if (!this.isReachable(index)) return;
      this.$store.dispatch('jumpToQuestion', index);
      this.$emit('jump');
    },
    answerLabel(item) {
      if (item.questionType === 'rangeSlider' && typeof item.answerValue === 'number' && item.answerValue >= 1 && item.answerValue <= 5) {
        const key = SLIDER_KEYS[item.answerValue - 1];
        return this.$t(`SliderQuestion.datalistOptions.${key}`);
      }
      return item.answerPreview || '';
    },
  },
};
</script>

<style scoped>
.sidebar-progress-bar :deep(.p-progressbar-value) {
  background: linear-gradient(135deg, #c83a77, #e44b55, #e4821a);
}

.sidebar-questions {
  min-height: 0;
}

.question-list-wrap {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #f49718 transparent;
  min-height: 0;
}

.question-list-text {
  display: block;
  text-align: left;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  line-height: 1.4;
  color: #111827;
}

</style>
